import { useTranslation } from 'react-i18next';

const TranslationText = ({ translationKey, translationFiles }) => {
  const { t, ready } = useTranslation(translationFiles);

  return ready ? t(translationKey) : '';
};

export default TranslationText;
